import { setCustomer } from '../slice/customer.pos.slice';
// import { setUser } from '../slice/user.web.slice';

export const customerUpdatedEvent = setCustomer;
// export const userUpdatedEvent = setUser;
